import ToastContainer from './ui/ToastContainer.vue';
import { useToastsStore } from './model/toastsStore';

const addToast = (message, type) => useToastsStore().addToast(message, type);

export { ToastContainer, addToast };
